/** Clés alignées sur `public.request_reactions.reaction_key` (check DB). */
export const REACTION_KEYS = ['fire', 'dance', 'chill', 'surprise', 'gem'];

/** @type {{ key: string, emoji: string, label: string }[]} */
export const REACTION_UI = [
  { key: 'fire', emoji: '🔥', label: 'Feu' },
  { key: 'dance', emoji: '💃', label: 'Danse' },
  { key: 'chill', emoji: '🧊', label: 'Cool' },
  { key: 'surprise', emoji: '😮', label: 'Waouh' },
  { key: 'gem', emoji: '💎', label: 'Pépite' },
];

/**
 * Titres et descriptions FR pour `public.event_user_badges.badge_code`.
 * @type {Record<string, { title: string, description: string }>}
 */
export const BADGE_INFO = {
  TREND_SETTER: {
    title: 'Tendance',
    description:
      'Tu as lancé une suggestion qui marque les esprits. Règle avancée (bientôt activée côté bar).',
  },
  FIRST_BLOOD: {
    title: 'Première suggestion',
    description: 'Tu as proposé la toute première musique de cette soirée.',
  },
  CROWD_KILLER: {
    title: 'Carton du bar',
    description: 'Une de tes suggestions a dépassé le seuil de popularité en votes.',
  },
  CERTIFIED_BANGER: {
    title: 'Certifié banger',
    description: 'Ta suggestion est en tête du classement des votes parmi les pistes encore en jeu.',
  },
  MAIN_CHARACTER: {
    title: 'Personnage principal',
    description: 'Tu as plusieurs suggestions en même temps dans le haut du classement.',
  },
  HIT_MACHINE: {
    title: 'Machine à tubes',
    description: 'Plusieurs de tes morceaux ont cartonné en votes pendant la même soirée.',
  },
  MVP: {
    title: 'MVP',
    description: 'Tu cumules le plus de votes sur tes suggestions : tu domines le podium de la soirée.',
  },
  VIRAL_PICK: {
    title: 'Choix viral',
    description: 'Ta suggestion a explosé en votes très peu de temps après sa publication.',
  },
  PERFECT_TIMING: {
    title: 'Timing parfait',
    description: 'Le DJ a joué ton morceau peu de temps après ta suggestion.',
  },
  MOOD_READER: {
    title: 'Lecteur d’ambiance',
    description: 'Tu proposes un morceau qui colle au mood du moment. Règle avancée à venir.',
  },
  CLUTCH_SAVE: {
    title: 'Relance collective',
    description: 'Ton morceau relance l’activité après un creux. Règle avancée à venir.',
  },
  LATE_NIGHT_HERO: {
    title: 'Héros de fin de nuit',
    description: 'Suggestion populaire après minuit. Règle avancée à venir.',
  },
  OPENING_CEREMONY: {
    title: 'Ouverture de bal',
    description: 'Premier gros morceau joué de la soirée, bien voté avant le passage.',
  },
  FINALE_BOSS: {
    title: 'Boss de finale',
    description: 'Dernier gros carton de la soirée. Règle avancée à venir.',
  },
  UNDERGROUND_PICKER: {
    title: 'Pépite underground',
    description: 'Morceau peu mainstream qui performe. Règle avancée (ex. métadonnées) à venir.',
  },
  DIGGING_MASTER: {
    title: 'Roi du crate digging',
    description: 'Sélection exigeante qui cartonne. Règle avancée à venir.',
  },
  HIDDEN_GEM: {
    title: 'Diamant brut',
    description:
      'Ta suggestion est passée sous les radars puis a pris de la hauteur — ou c’était un beau pari au moment où le DJ l’a jouée.',
  },
  CURVEBALL: {
    title: 'Lancer surprise',
    description: 'Suggestion très différente du reste de la file. Règle avancée à venir.',
  },
  PEOPLES_CHOICE: {
    title: 'Choix du public',
    description: 'Tes morceaux ont reçu énormément de réactions emoji de la part du bar.',
  },
  CROWD_FAVORITE: {
    title: 'Chouchou de la salle',
    description: 'Le cumul des votes sur toutes tes suggestions de la soirée est impressionnant.',
  },
  SOCIAL_ANIMAL: {
    title: 'Animal social',
    description: 'Tu as participé très activement aux votes pendant cette soirée.',
  },
  SUPPORTER: {
    title: 'Supporter',
    description: 'Tu fais monter plusieurs morceaux qui finissent par être joués. Règle avancée à venir.',
  },
  TASTE_MAKER: {
    title: 'Tête d’affiche des paliers',
    description: 'Un palier de cagnotte a été atteint : tu es le plus gros contributeur payant identifié.',
  },
  VILLAIN: {
    title: 'Vilain personnage',
    description:
      'Une de tes suggestions polarise : beaucoup de réactions « cool » par rapport au feu — le bar débat.',
  },
  RISKY_MOVE: {
    title: 'Coup de poker',
    description: 'Suggestion audacieuse. Règle avancée à venir.',
  },
  CHAOS_AGENT: {
    title: 'Agent du chaos',
    description: 'Tu casses volontairement le style en cours. Règle avancée à venir.',
  },
  POLARIZING_PICK: {
    title: 'Choix clivant',
    description: 'Autant d’amour que de détente sur les réactions. Règle avancée à venir.',
  },
  DJ_TESTER: {
    title: 'Testeur de transitions',
    description: 'Tu proposes des enchaînements improbables. Règle avancée à venir.',
  },
  NIGHT_OWL: {
    title: 'Oiseau de nuit',
    description: 'Tu votes (ou participes) en pleine nuit selon le fuseau du bar.',
  },
  EARLY_BIRD: {
    title: 'Lève-tôt',
    description: 'Tu es très actif en début de soirée (créneau horaire local du bar).',
  },
  MARATHON_PLAYER: {
    title: 'Marathonien',
    description: 'Tu restes actif très longtemps. Règle avancée à venir.',
  },
  HYPERACTIVE: {
    title: 'Hyperactif',
    description: 'Tu as donné une quantité très élevée de votes pendant la soirée.',
  },
  ON_FIRE: {
    title: 'En feu',
    description: 'Tes dernières suggestions s’enchaînent et performent toutes en votes.',
  },
  UNTOUCHABLE: {
    title: 'Intouchable',
    description: 'Personne ne te rattrape au classement pendant un moment. Règle avancée à venir.',
  },
  BACK_TO_BACK: {
    title: 'Dos à dos',
    description: 'Deux morceaux joués d’affilée venaient de toi.',
  },
  WINNING_STREAK: {
    title: 'Série gagnante',
    description: 'Plusieurs suggestions positives d’affilée. Règle avancée à venir.',
  },
  DANCEFLOOR_IGNITER: {
    title: 'Allume-piste',
    description: 'Tes morceaux déclenchent une avalanche de réactions « danse ».',
  },
  VIBE_CONTROLLER: {
    title: 'Chef d’ambiance',
    description: 'Tu influences fortement le mood de la room. Règle avancée à venir.',
  },
  ENERGY_BOOSTER: {
    title: 'Boost d’énergie',
    description: 'Tu fais monter l’énergie moyenne de la file. Règle avancée à venir.',
  },
  CHILL_MASTER: {
    title: 'Maître du chill',
    description: 'Tu domines les moments plus calmes. Règle avancée à venir.',
  },
  LUCKY_SHOT: {
    title: 'Coup de chance',
    description: 'Une seule suggestion dans la soirée, mais elle explose. Règle avancée à venir.',
  },
  SILENT_ASSASSIN: {
    title: 'Assassin silencieux',
    description: 'Tu montes discrètement au classement. Règle avancée à venir.',
  },
  COMEBACK_KING: {
    title: 'Roi du comeback',
    description: 'Tu passes d’un mauvais classement au podium. Règle avancée à venir.',
  },
  ONE_HIT_WONDER: {
    title: 'Tube éclair',
    description: 'Un seul énorme succès dans la soirée. Règle avancée à venir.',
  },
};

/**
 * Emoji par badge_code (vitrine à trophées, pastilles live).
 * @type {Record<string, string>}
 */
export const BADGE_EMOJI = {
  TREND_SETTER: '📈',
  FIRST_BLOOD: '🩸',
  CROWD_KILLER: '💥',
  CERTIFIED_BANGER: '💿',
  MAIN_CHARACTER: '🌟',
  HIT_MACHINE: '🎰',
  MVP: '🏆',
  VIRAL_PICK: '🦠',
  PERFECT_TIMING: '⏱️',
  MOOD_READER: '🔮',
  CLUTCH_SAVE: '🆘',
  LATE_NIGHT_HERO: '🌙',
  OPENING_CEREMONY: '🎬',
  FINALE_BOSS: '👑',
  UNDERGROUND_PICKER: '🕳️',
  DIGGING_MASTER: '⛏️',
  HIDDEN_GEM: '💎',
  CURVEBALL: '🎯',
  PEOPLES_CHOICE: '🫶',
  CROWD_FAVORITE: '❤️‍🔥',
  SOCIAL_ANIMAL: '🦁',
  SUPPORTER: '🤝',
  TASTE_MAKER: '🎨',
  VILLAIN: '😈',
  RISKY_MOVE: '🎲',
  CHAOS_AGENT: '🌀',
  POLARIZING_PICK: '⚡',
  DJ_TESTER: '🎚️',
  NIGHT_OWL: '🦉',
  EARLY_BIRD: '🐦',
  MARATHON_PLAYER: '🏃',
  HYPERACTIVE: '🤸',
  ON_FIRE: '🔥',
  UNTOUCHABLE: '🛡️',
  BACK_TO_BACK: '🔁',
  WINNING_STREAK: '🎖️',
  DANCEFLOOR_IGNITER: '💃',
  VIBE_CONTROLLER: '🎛️',
  ENERGY_BOOSTER: '🚀',
  CHILL_MASTER: '🧊',
  LUCKY_SHOT: '🍀',
  SILENT_ASSASSIN: '🥷',
  COMEBACK_KING: '🔙',
  ONE_HIT_WONDER: '🎆',
};

/** Liste ordonnée de tous les codes du catalogue (vitrine : gagnés + verrouillés). */
export const ALL_BADGE_CODES = Object.keys(BADGE_INFO);

/**
 * @param {string} code
 * @returns {{ title: string, description: string, emoji: string }}
 */
export function getBadgeInfo(code) {
  const key = String(code ?? '').trim();
  if (BADGE_INFO[key]) return { ...BADGE_INFO[key], emoji: BADGE_EMOJI[key] ?? '🏅' };
  return {
    title: key.replace(/_/g, ' ') || 'Badge',
    description: 'Badge obtenu pendant cette soirée.',
    emoji: '🏅',
  };
}

/** Rétrocompat : titre court seul (ex. pastilles compactes). */
export const BADGE_LABELS = Object.fromEntries(
  Object.entries(BADGE_INFO).map(([k, v]) => [k, v.title])
);
